import { BasePortal } from './BasePortal';

export class WebPortal extends BasePortal {
	name = 'WebPortal';
	autoLogin = false;
	config = {};
	constructor(config) {
		super();
		this.config.version = config?.version;
	}
	async init() {
		//set update google analytics dynamically
		//some platforms may block google analytics, so only add it for web portal
		this.addGoogleAnalytics(this.config.version); //no await no - fire and forget
	}
	//todo: move to lib so other portals can use it too
	async addGoogleAnalytics(version) {
		console.log('WebPortal: Initializing Google Analytics');
		//set update google analytics dynamically
		await import('https://www.googletagmanager.com/gtag/js?id=G-BMWB7H1PDJ');
		window.dataLayer = window.dataLayer || [];
		function gtag() { dataLayer.push(arguments); }
		gtag('js', new Date());

		gtag('config', 'G-BMWB7H1PDJ', {
			app_version: version
		});// for Cribbage all platforms
		gtag('config', 'G-SBZ83TJLW6');// for website cardsjd.com
	}
}
